import React from "react"
import styled from "styled-components"
import { linkAccent, breakpointMedium } from "../variables"

const PostTextSection = ({ slice }) => {
  const { content } = slice.primary

  return <TextContainer dangerouslySetInnerHTML={{ __html: content.html }} />
}

export default PostTextSection

const TextContainer = styled.div`
  font-size: 24px;
  line-height: 36px;
  margin-top: 36px;
  padding: 0 20px;

  a {
    color: ${linkAccent};
  }

  @media (min-width: ${breakpointMedium}) {
    padding: 0;
  }
`

